export default "__VITE_ASSET__3cd66f1e__"